import { ChangeEvent, Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button, CardMedia, Input } from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddCategory({
    open,
    onClose,
    setOpen,
}: ModalProps) {

    const [image, setImage] = useState<string>("");

    const [fileName, setFileName] = useState<string>("");
    return (
        <Modal
            className="modal rejectReason_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog">
                <div className="modal-body">
                    <div className="modal_title">
                        <h2>Add Category</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                            aria-label="Close"
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    <form className="form" action="">
                        <div className="control_group w_50">
                            <label htmlFor="icon-button-file">
                                Upload Image<span className="req">*</span>
                            </label>
                            {image ? (
                                <div className="upload_image">
                                    <div className="upload_image_holder no_radius v2">
                                        <figure>
                                            <CardMedia component="img" image={image} alt="photo" />
                                        </figure>
                                        <CloseIcon
                                            onClick={() => {
                                                setImage("");
                                                setFileName("");
                                            }}
                                        />
                                    </div>
                                </div>
                            ) : (
                                <label className="upload_image" htmlFor="icon-button-file">
                                    <Input
                                        sx={{ display: "none" }}
                                        id="icon-button-file"
                                        type="file"
                                        inputProps={{ accept: "image/png,image/jpeg" }}
                                        onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                            const files = event.target.files;
                                            if (files && files[0].type.includes("image")) {
                                                setFileName(files[0].name);
                                                setImage(URL.createObjectURL(files[0]));
                                            }
                                        }}
                                    />
                                    <span className="upload_image_holder no_radius">
                                        <figure className="add_img">
                                            <img src="/static/images/placeholder.png" alt="icon" />
                                            <span className="upload_img_icon">
                                                <img src="/static/images/edit2_icon.svg" alt="icon" />
                                            </span>
                                        </figure>
                                    </span>
                                </label>
                            )}
                        </div>
                        <div className="control_group">
                            <label htmlFor="reject-reason">Category Name</label>
                            <TextField
                                id="reject-reason"
                                placeholder="Enter Name"
                                fullWidth
                                hiddenLabel

                            />
                        </div>

                        <div className="footer_btn_flex">

                            <Button
                                className="btn btn_grey"
                                onClick={() => setOpen(false)}
                            >
                                Generate with AI
                            </Button>
                            <Button
                                className="btn btn_primary"
                                onClick={() => setOpen(false)}
                            >
                                Save
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
}
